// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2z9GX","location":"Header_location__2ZOif"};